import { StyleSheet } from 'react-native';

import ThemeColor from '../../Theme/colors';
import ThemeStyle from '../../Theme/styles';

const iconSize = 20;

export default StyleSheet.create({
  mealplanNavigationWrapper: {
    ...ThemeStyle.shadow,
    ...ThemeStyle.spacingBottomMedium,
    backgroundColor: ThemeColor.white,
    borderRadius: 50,
  },
  wrapper: {
    ...ThemeStyle.pageHorizontalSpacing,
    ...ThemeStyle.shadow,
    backgroundColor: ThemeColor.green,
    borderRadius: 50,
  },
  textContainer: [
    ThemeStyle.flex1,
    ThemeStyle.alignItemsCenter,
    ThemeStyle.pageHorizontalSpacingSmall,
  ],
  icon: {
    width: iconSize,
    height: iconSize,
  },
  qty: {
    minWidth: iconSize,
    textAlign: 'center',
  },
  btnCtrl: {
    ...ThemeStyle.fullRoundCorder,
    ...ThemeStyle.pageBackground,
    ...ThemeStyle.shadow,
    paddingVertical: 0,
    paddingHorizontal: 0,
  },
});
